import { render } from "./TvmSlideOutServiceSpecial.vue?vue&type=template&id=145ecb5b&scoped=true"
import script from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutServiceSpecial.vue?vue&type=script&lang=js"

import "./TvmSlideOutServiceSpecial.vue?vue&type=style&index=0&id=145ecb5b&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145ecb5b"]])

export default __exports__